<template>
  <div
    :style="`
		background-color: ${backgroundColor};
		color: ${textColor};
		width: ${size}px;
		height: ${size}px;
		font-size: ${fontSize}px;
	`"
    class="avatar"
  >
    <span>{{ onInitials }}</span>
  </div>
</template>

<script>
export default {
  props: {
    initials: {
      type: String,
      required: true
    },
    backgroundColor: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 80
    },
    fontSize: {
      type: Number,
      default: 36
    }
  },
  computed: {
    onInitials() {
      return this.initials.toUpperCase();
    },
    textColor() {
      const color = this.backgroundColor;

      const r = parseInt(color.substr(1, 2), 16);
      const g = parseInt(color.substr(3, 2), 16);
      const b = parseInt(color.substr(5, 2), 16);

      // Calcula o contraste usando a fórmula WCAG 2.0
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 130 ? 'black' : 'white';
    }
  }
};
</script>

<style>
.avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 2px solid white;
  font-weight: bold;
}

.avatar span {
  line-height: 1;
}
</style>
